import { motion } from "framer-motion";

export const LogoMonogram = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" data-testid="brand-logo" aria-label="Smart Telecom Advisor logo">
    <rect width="40" height="40" rx="9" fill="#FF7900" />
    <text
      x="20"
      y="26.5"
      textAnchor="middle"
      fontFamily="'Space Grotesk', 'Inter', sans-serif"
      fontWeight="700"
      fontSize="14.5"
      letterSpacing="-0.5"
      fill="#FFFFFF"
    >
      STA
    </text>
  </svg>
);

export const LogoBolt = ({ size = 36, intro = false }) => {
  if (!intro) {
    return (
      <svg width={size} height={size} viewBox="0 0 40 40" data-testid="brand-logo" aria-label="Smart Telecom Advisor logo">
        <rect width="40" height="40" rx="20" fill="#FF7900" />
        <circle cx="20" cy="20" r="15" fill="none" stroke="#FFFFFF" strokeWidth="2" opacity="0.35" />
        <path d="M22.5 9.5 L13.5 22 h5.5 L17.5 30.5 L26.5 18 h-5.5 Z" fill="#FFFFFF" />
      </svg>
    );
  }
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" data-testid="brand-logo" aria-label="Smart Telecom Advisor logo">
      <motion.rect
        width="40" height="40" rx="20" fill="#FF7900"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      />
      <motion.circle
        cx="20" cy="20" r="15" fill="none" stroke="#FFFFFF" strokeWidth="2"
        initial={{ pathLength: 0, opacity: 0 }}
        animate={{ pathLength: 1, opacity: 0.35 }}
        transition={{ duration: 1.2, ease: "easeInOut", delay: 0.4 }}
      />
      <motion.path
        d="M22.5 9.5 L13.5 22 h5.5 L17.5 30.5 L26.5 18 h-5.5 Z" fill="#FFFFFF"
        initial={{ opacity: 0, y: -6 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ type: "spring", stiffness: 220, damping: 13, delay: 1.1 }}
      />
    </svg>
  );
};

export const Logo = LogoBolt;
